import {Component, HostListener, OnInit} from '@angular/core';
import {Path} from 'src/app/util/path';
import {faHeadset, faChalkboardTeacher} from '@fortawesome/free-solid-svg-icons';
import {faEnvelopeOpen} from '@fortawesome/free-regular-svg-icons';
import {NovoUnidadeJurisdicionalService} from '../../services/novo-unidade-jurisdicional.service';
import {NovoUnidadeJurisdicional} from '../../modelos/novoUnidadeJurisdicional';

@Component({
    selector: 'app-cabecalho-barra-lateral',
    templateUrl: './cabecalho-barra-lateral.component.html',
    styleUrls: ['./cabecalho-barra-lateral.component.scss'],
    standalone: false
})
export class CabecalhoBarraLateralComponent implements OnInit {

    pathFormularioSIC = Path.SIC_OUVIDORIA_FORMULARIO;
    pathCanaisAtendimento = Path.CANAIS_ATENDIMENTO;
    pathBalcao = Path.BALCAO_VIRTUAL;
    pathCentralDeAtendimento = Path.CENTRAL_DE_ATENDIMENTO;
    rotaTurmaRecursal: string = Path.PAGINAS_SETORIAIS.caminho;
    ujTurmaRecursal!: NovoUnidadeJurisdicional;

    menuLateralVisivel: boolean = false;

    constructor(private unidadeJurisdicionalService: NovoUnidadeJurisdicionalService) {
    }

    ngOnInit(): void {
      this.buscarTurmaRecursalId();
    }

    ocultarExibicaoMenuLateral(): any {
        this.menuLateralVisivel = !this.menuLateralVisivel;
    }

    isSticky: boolean = false;

    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        this.isSticky = window.pageYOffset >= 0;
    }

    /* FONTAWESOME */
    faEnvelopeOpen = faEnvelopeOpen;
    faHeadset = faHeadset;
    faChalkboardTeacher = faChalkboardTeacher;
    /* END FONTAWESOME */

  buscarTurmaRecursalId(): void{
    const turmaRecursalNome = Path.TURMA_RECURSAL.nomeExibicao;
    // this.loading = true;
    this.unidadeJurisdicionalService.buscarUnidadeJurisdicionalPorNome(turmaRecursalNome).toPromise().then((res: any) => {
      this.ujTurmaRecursal = res;
      this.rotaTurmaRecursal += `/${Path.SETOR.caminho}?setor=${this.ujTurmaRecursal.id}`;
      // this.loading = false;
    }).catch(() => {
      console.error(`Não foi possível localizar a rota para ${turmaRecursalNome}. Por favor entre em contato com o NTIC.`);
    });
  }

}
